import AthleteService from "services/AthleteService";
import useMutation from "hooks/useMutation";

export interface UseAthleteResendWelcomeEmailMutationProps {
  /** Only part of the mutation key: the athlete the request acts on comes from the trigger argument. */
  athleteId?: string;
}

export interface AthleteResendWelcomeEmailArg {
  athleteId: string;
}

/**
 * @description Sends the welcome email again to an athlete who has already joined Capture.
 * Their email address is confirmed at this point, so there is nothing to patch in the athletes store.
 */
function useAthleteResendWelcomeEmailMutation(props: UseAthleteResendWelcomeEmailMutationProps) {
  const queryKey = ["AthleteService.resendWelcomeEmail", props.athleteId];

  return useMutation<void, Error, typeof queryKey, AthleteResendWelcomeEmailArg>(queryKey, async (_, { arg }) =>
    AthleteService.resendWelcomeEmail(arg.athleteId)
  );
}

export default useAthleteResendWelcomeEmailMutation;
